namespace $ { $mol_style_attach( "mol/infinite/infinite.view.css",
 "[mol_infinite_before],\n[mol_infinite_after] {\n\toverflow-anchor: none;\n}\n\n[mol_infinite_after][mol_view_error=\"Promise\"] {\n\theight: 100vh;\n}\n"
) }